import * as React from 'react';

import * as styles from './SpecificationColumn.css';

export const SpecificationColumn = (props: React.PropsWithChildren): React.JSX.Element => {
  return <div className={styles['container']}>{props.children}</div>;
};
